<template>
    <div>
        <div>
            <h3>Liste des invitations</h3>
        </div>
        <v-snackbar v-model="snackbar" :timeout="5000" :color="snackbar_color" :top="true" :right="true">
            {{ snackbar_message }}
        </v-snackbar>
        <div class="text-center" v-if="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <div>
                <v-layout column class="mt-10">
                    <v-flex xs12>
                        <v-layout align-center justify-end fill-height>
                            <v-text-field v-model="search" label="Filter par email ou username" solo class="mr-2">
                                <template v-slot:append-outer>
                                    <v-btn rounded color="primary" class="text-capitalize mr-2"
                                        :disabled="selected.length < 1" @click="dialog_bulk = true"
                                        v-if="$can('delete users')">
                                        Supprimer
                                        <v-icon right>mdi-check</v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </div>
            <v-data-table v-model="selected" v-if="users" :headers="headers" :loading="load" :items="users" show-select
                :mobile-breakpoint="600" loading-text="Loading... Please wait" :page.sync="currentPage"
                :server-items-length="totalItems" :items-per-page.sync="rowsPerPage" :footer-props="footerProps"
                class="mt-2 mr-10">
                <template v-slot:item.full_name="{ item }">
                    <td>

                        {{ item.full_name }}
                    </td>
                </template>
                <template v-slot:item.action="{ item }">
                    <!-- <v-icon small class="mr-2" @click="editItem(item)"
                        v-if="item.roles[0] && item.roles[0].name !== 'super administrator' && item.email !== authUser.email && authUser.user.roles[0].name === 'super administrator' && $can('edit users')">
                        mdi-pencil-outline
                    </v-icon> -->
                    <v-icon small @click="deleting(item)"
                        v-if="item.roles[0] && item.roles[0].name !== 'super administrator' && item.email !== authUser.email && (authUser.user.roles[0].name === 'super administrator' || authUser.user.roles[0].name === 'administrateur') && $can('delete users')">
                        mdi-trash-can-outline
                    </v-icon>
                </template>
            </v-data-table>
        </div>
        <v-layout justify-center>
            <v-dialog v-model="dialog" persistent hide-overlay max-width="290">
                <v-card>
                    <v-card-title class="headline">Suppression</v-card-title>
                    <v-card-text>{{ delete_message }}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn rounded color="orange" @click="dialog = false">Non</v-btn>
                        <v-btn rounded color="primary" @click="deleteItem()">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialog_bulk" persistent hide-overlay max-width="290">
                <v-card>
                    <v-card-title class="headline">Suppression</v-card-title>
                    <v-card-text>Etes-vous sûr de vouloir supprimer ces utilisateurs ?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn rounded color="orange" @click="dialog_bulk = false">Non</v-btn>
                        <v-btn rounded color="primary" @click="bulkDelete()" :loading="load"
                            :disabled="load">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout justify-center>
            <v-dialog v-model="formDialog" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="headline primary--text">Envoyer l'email d'invitation</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field v-model="invitation.email" label="Email*" required solo>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-select v-model="invitation.role" :items="getRoles" item-text="name"
                                        item-value="name" label="Role*" required solo></v-select>
                                </v-flex>
                                <v-flex xs12 v-if="invitation && invitation.role == 'Moderator SAE'">
                                    <v-select v-model="invitation.sae_type_id" :items="sae_types" item-text="name"
                                        item-value="id" label="SAE*" required solo></v-select>
                                </v-flex>
                                <v-flex xs12 v-if="invitation && invitation.role == 'Moderator staff ACMA 3'">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-autocomplete v-model="invitation.department_id" :items="departments"
                                                item-text="name" item-value="id"
                                                :rules="[v => !!v || 'Département requis']" label="Département"
                                                clearable solo @input="chooseMunicipality(invitation.department_id)"
                                                required v-validate="'required'"></v-autocomplete>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-autocomplete v-model="invitation.municipality_id" :items="municipalities"
                                                item-text="name" item-value="id"
                                                :rules="[v => !!v || 'Commune requise']" label="Commune" multiple
                                                clearable solo></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-flex>
                                <v-flex xs12 v-if="withPassword">
                                    <v-text-field v-model="invitation.password" label="Mot de passe*" required solo>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <small>*indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info darken-1" @click="formDialog = false">Annuler</v-btn>
                        <v-btn color="primary" :loading="loading" :disabled="loading"
                            @click="sendInvitation()">Envoyer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="editRole" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="headline primary--text">Modification</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field disabled v-model="editedUser.email" label="Email*" required solo>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 v-if="editedUser.role">
                                    <v-select v-model="editedUser.role" :items="getRoles" item-text="name"
                                        item-value="name" label="Role*" required solo></v-select>
                                </v-flex>
                                <v-flex xs12 v-if="editedUser.role && editedUser.role == 'Moderator SAE'">
                                    <v-select v-model="editedUser.sae_type_id" :items="sae_types" item-text="name"
                                        item-value="id" label="SAE*" required solo></v-select>
                                </v-flex>
                                <v-flex xs12
                                    v-if="editedUser.role && (editedUser.role == 'Moderator staff ACMA 3' || editedUser.role == 'Moderator SAE' || editedUser.role == 'Animateur')">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-autocomplete v-model="editedUser.department_id" :items="departments"
                                                item-text="name" item-value="id"
                                                :rules="[v => !!v || 'Département requis']" label="Département"
                                                clearable solo @input="chooseMunicipality(editedUser.department_id)"
                                                required v-validate="'required'"></v-autocomplete>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-autocomplete v-model="editedUser.municipality_id" :items="municipalities"
                                                item-text="name" item-value="id"
                                                :rules="[v => !!v || 'Commune requise']" label="Commune" multiple
                                                clearable solo></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <small>*indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="info darken-1" @click="editRole = false">Annuler</v-btn>
                        <v-btn color="primary" :loading="load" :disabled="load" @click="save()">Envoyer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>
<script>
import { mapGetters } from "vuex"
import axios from "axios"
import Permissions from '~/mixins/Permissions';

export default {
    name: "invitations-list-view",
    mixins: [Permissions],
    data() {
        return {
            invitation: {
                email: '',
                role: ''
            },
            formDialog: false,
            userId: null,
            dialog: false,
            dialog_bulk: false,
            loading: false,
            load: false,
            snackbar: false,
            snackbar_message: '',
            delete_message: '',
            snackbar_color: '',
            headers: [
                { text: "Nom Complet", value: "username", width: 150 },
                { text: "Email", value: "email" },
                { text: "Role", value: "roles[0].name" },
                { text: "Date d'ajout", value: "created_at" },
                { text: "Actions", value: "action", sortable: false },
            ],
            payload: { page: 1, size: 15 },
            footerProps: {
                "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
                "items-per-page-text": "Lignes par page",
            },
            editRole: false,
            editedIndex: -1,
            editedUser: {
                role: null,
                sae_type_id: null,
                municipality_id: null
            },
            withPassword: false,
            selected: [],
            ids: [],
            search: ''
        }
    },
    created() {
        this.$checkPermission('view users')
        this.fetchUtils()
    },
    watch: {
        'search'(newVal, oldVal) {
            this.payload.search = newVal;
            this.fetchUtilsSearch();
        },
        'editedUser.role'(newVal, oldVal) {
            if (newVal && oldVal) {
                if (newVal !== oldVal) {
                    this.editedUser.sae_type_id = null
                    this.editedUser.municipality_id = null
                    this.editedUser.department_id = null
                }
            }
        },
    },
    computed: {
        totalItems() {
            return this.$store.getters.userPaginate.total;
        },
        rowsPerPage: {
            get: function () {
                return this.$store.getters.userPaginate.rowsPerPage;
            },

            set: function (value) {
                const old = this.payload.size
                this.payload.size = value;
                if (old != this.payload.size) this.fetchUtils();
            },
        },
        currentPage: {
            get: function () {
                return this.$store.getters.userPaginate.current_page;
            },

            set: function (value) {
                const old = this.payload.page
                this.payload.page = value;
                if (old != this.payload.page) this.fetchUtils();
            },
        },
        sae_types() {
            return this.$store.getters.sae_types;
        },
        pagination() {
            return this.$store.getters.pagination;
        },
        departments() { return this.$store.getters.getDepartments },
        municipalities() { return this.$store.getters.getMunicipalities },
        ...mapGetters([
            'users',
            'getRoles',
            'authUser'
        ])
    },
    methods: {
        chooseMunicipality(value) {
            this.editedUser.municipality_id = null
            this.invitation.municipality_id = null
            this.$store.dispatch('loadMunicipalities', value);
        },
        deleting(item) {
            this.userId = item.id
            this.delete_message = 'Etes-vous sûr de vouloir supprimer cet utilisateur ?'
            this.dialog = true
        },
        async deleteItem() {
            await this.$store.dispatch('deleteUser', this.userId)
            this.dialog = false
            this.snackbar = true
            this.snackbar_color = "primary";
            this.snackbar_message = "Utilisateur supprimé avec succès!"
            await this.fetchUtils()
        },
        async bulkDelete() {
            this.ids = this.selected.map((item) => {
                return item.id;
            });

            this.load = true;
            await this.$store.dispatch("deleteUsers", this.ids);

            this.load = false;
            this.dialog_bulk = false;
            this.snackbar = true;
            this.selected = [];
            this.snackbar_message = "Acteurs supprimés avec succès!";
            this.fetchUtils()
        },
        openInvitation(value) {
            this.formDialog = true
            this.withPassword = value
        },
        editItem(item) {
            this.editedUser.id = item.id
            this.editedUser.email = item.email
            this.editedUser.role = item.roles[0].name
            this.editedUser.sae_type_id = null
            if (this.editedUser.role == 'Moderator SAE' && item.interventions.length > 0) {
                this.editedUser.sae_type_id = item.interventions[0].sae_type_id
                if (item.interventions.length > 1) {
                    this.editedUser.department_id = item.interventions[1].department_id
                    this.chooseMunicipality(this.editedUser.department_id)
                    const municipalityIds = item.interventions.map(intervention => intervention.municipality_id)
                    this.editedUser.municipality_id = municipalityIds
                }
            } else if (this.editedUser.role == 'Moderator staff ACMA 3' && item.interventions.length > 0) {
                this.editedUser.department_id = item.interventions[0].department_id
                this.chooseMunicipality(this.editedUser.department_id)
                const municipalityIds = item.interventions.map(intervention => intervention.municipality_id)
                this.editedUser.municipality_id = municipalityIds
            }
            this.editRole = true
        },
        async save() {
            if (this.editedUser.role == "Moderator SAE" && !this.editedUser.sae_type_id) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Le type sae est obligatoire.";
                return;
            }
            if ((this.editedUser.role === 'Moderator staff ACMA 3' || this.editedUser.role === 'Moderator SAE') && (this.editedUser.municipality_id == null || (this.editedUser.department_id && this.editedUser.department_id.length == 0))) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Merci de remplir tous les champs de la zone intervention.";
                return;
            }

            this.load = true
            await this.$store.dispatch("updateUserRole", this.editedUser).then(response => {
                this.snackbar = true;
                this.snackbar_color = 'success';
                this.snackbar_message = "Le role de l'utilisateur à été modifié avec succès";
                this.editRole = false
                this.load = false

                this.editedUser.sae_type_id = null
                this.editedUser.municipality_id = null
                this.editedUser.department_id = null

                this.fetchUtils()
            }).catch(err => {
                console.log(' Invitation sending error ', err)
                this.editRole = false
                this.load = false
            })
        },
        async fetchUtils() {
            this.loading = true;
            await this.$store.dispatch("fetchInvitationUsers", this.payload);
            this.loading = false;
        },
        async fetchUtilsSearch() {
            this.load = true;
            await this.$store.dispatch("fetchInvitationUsers", this.payload);
            this.load = false;
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/users/invitation-list.vue